import DeviceDetector from "device-detector-js";
import { Notifier } from "@airbrake/browser";

window.deviceDetector = new DeviceDetector();
window.device = window.deviceDetector.parse(navigator.userAgent);

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();
window.abortController = undefined;

import AuthorizeInteractionController from "./controllers/authorize_interaction_controller";
import BodyScrollController from "./controllers/body_scroll_controller";
import ButtonCopyController from "./controllers/button_copy_controller";
import ContactController from "./controllers/contact_controller";
import DeviceDetectorController from "./controllers/device_detector_controller";
import FootnotesController from "./controllers/footnotes_controller";
import ModalController from "./controllers/modal_controller";
import PagefindController from "./controllers/pagefind_controller";
import SupportUsController from "./controllers/support_us_controller";
import TabsController from "./controllers/tabs_controller";

Stimulus.debug = window.env.JEKYLL_ENV !== "production";
Stimulus.register("authorize-interaction", AuthorizeInteractionController);
Stimulus.register("body-scroll", BodyScrollController);
Stimulus.register("button-copy", ButtonCopyController);
Stimulus.register("contact", ContactController);
Stimulus.register("device-detector", DeviceDetectorController);
Stimulus.register("footnotes", FootnotesController);
Stimulus.register("modal", ModalController);
Stimulus.register("pagefind", PagefindController);
Stimulus.register("support-us", SupportUsController);
Stimulus.register("tabs", TabsController);

document.addEventListener("turbo:load", (event) => {
  window.abortController = new AbortController();
});

document.addEventListener("turbo:visit", (event) => {
  window.abortController.abort();
});
